module.exports = __webpack_public_path__ + "img/ci_dlcon.adcaee93.png";